


























import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Modal from '@/components/Modal.vue'
import Switcher from '@/components/Switcher.vue'
import { UserModule } from '@/store/modules/user.module'
import { IUserAlertSettings, EUserAlertSettingsStatus } from '@zunta/configurations'

@Component({
  components: {
    Modal,
    Switcher
  }
})
export default class AlertSettingsModal extends Vue {
  userModuleInstance: UserModule = getModule(UserModule, this.$store);
  settings: IUserAlertSettings[] = [];
  EUserAlertSettingsStatus: any = EUserAlertSettingsStatus

  get userAlertSettings () {
    return this.$store.state.user.userAlertSettings
  }

  mounted () {
    this.settings = JSON.parse(JSON.stringify(this.userAlertSettings))
  }

  changeSettingStatus (setting:IUserAlertSettings, value: boolean) {
    if (value) {
      setting.status = EUserAlertSettingsStatus.ENABLED
    } else {
      setting.status = EUserAlertSettingsStatus.DISABLED
    }
  }

  async submit () {
    await this.userModuleInstance.updateUserAlertSettings(this.settings)
    this.$emit('close')
  }
}
